import { AccessLevel, UserType } from '../models/interfaces';

// Niveles de administración: plataforma -> banco -> comercio
export const LEVEL_LABEL: Record<AccessLevel, string> = {
    PLATAFORMA: 'Plataforma',
    BANCO: 'Banco',
    COMERCIO: 'Comercio',
};

export const LEVEL_ICON: Record<AccessLevel, string> = {
    PLATAFORMA: 'bi-globe2',
    BANCO: 'bi-bank',
    COMERCIO: 'bi-shop',
};

export const USER_TYPE_LABEL: Record<UserType, string> = {
    PORTAL: 'Portal',
    OPERADOR: 'Operador (POS)',
};

export const errorMessage = (e: any, fallback = 'Ocurrió un error de comunicación, intente de nuevo.'): string =>
    e?.response?.data?.error || fallback;

// ¿El usuario en sesión es de nivel plataforma? (grupos con NIVEL, o los nombres anteriores a la migración)
export const isPlatformUser = (user: any): boolean =>
    (user?.groups ?? []).some((group: any) =>
        group?.level === 'PLATAFORMA' || ['Administrator', 'Backoffice'].includes(group?.name));

// Usuarios de plataforma o de banco: eligen el comercio en los reportes (los de comercio usan el suyo)
export const canFilterMerchants = (user: any): boolean =>
    isPlatformUser(user) || (user?.groups ?? []).some((group: any) => group?.level === 'BANCO');
